"use strict";

exports.__esModule = true;
exports.updateMe = exports.signUp = exports.signOut = exports.signIn = exports.resetPassword = exports.requestCode = exports.quit = exports.newPassword = exports.init = exports.getSession = exports.getMe = exports.deleteSession = exports.createSession = exports.changePassword = exports.authenticate = void 0;
var _awsAmplify = require("aws-amplify");
var _helpers = require("../../helpers");
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
var _actionTypes = require("./actionTypes");
const createSession = idToken => {
  return dispatch => {
    return (0, _WebRequestHelper.createRequest)(false).then(request => {
      if (idToken) {
        dispatch({
          type: _actionTypes.CREATE_SESSION_REQUEST
        });
        request.method = "post";
        request.url = `/sessions?type=ControlPanel`;
        request.headers = {
          Authorization: `${idToken}`
        };
        return (0, _WebRequestHelper.sendRequest)(request).then(response => {
          console.log("Response in createSession:", response);
          dispatch({
            type: _actionTypes.CREATE_SESSION_SUCCESS,
            data: response.data
          });
          return response.data;
        }).catch(error => {
          console.error("Error in createSession:", error.message);
          dispatch({
            type: _actionTypes.CREATE_SESSION_FAILURE,
            data: error.message
          });
          throw error.message;
        });
      }
    }).catch(error => {
      console.dir(error);
      throw error;
    });
  };
};
exports.createSession = createSession;
const deleteSession = idToken => {
  return dispatch => {
    return (0, _WebRequestHelper.createRequest)(false).then(request => {
      if (idToken) {
        dispatch({
          type: _actionTypes.DELETE_SESSION_REQUEST
        });
        request.method = "delete";
        request.url = `/sessions`;
        request.headers = {
          Authorization: `${idToken}`
        };
      }
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        console.log("Response in deleteSession:", response);
        dispatch({
          type: _actionTypes.DELETE_SESSION_SUCCESS,
          data: response.data
        });
        return response.data;
      });
    }).catch(error => {
      console.error("Error in deleteSession:", error.message);
      dispatch({
        type: _actionTypes.DELETE_SESSION_FAILURE,
        data: error.message
      });
      throw error.message;
    });
  };
};
exports.deleteSession = deleteSession;
const getSession = idToken => {
  return dispatch => {
    return (0, _WebRequestHelper.createRequest)(true).then(request => {
      if (idToken) {
        dispatch({
          type: _actionTypes.GET_SESSION_REQUEST
        });
        request.method = "get";
        request.url = `/sessions`;
      }
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        // console.log("Response in getSession:", response);

        dispatch({
          type: _actionTypes.GET_SESSION_SUCCESS,
          data: response.data
        });
        return response.data;
      });
    }).catch(error => {
      console.error("Error in getSession:", error.message);
      dispatch({
        type: _actionTypes.GET_SESSION_FAILURE,
        data: error.message
      });
      throw error.message;
    });
  };
};
exports.getSession = getSession;
const init = data => {
  return dispatch => dispatch({
    type: _actionTypes.INIT_AUTH,
    data
  });
};
exports.init = init;
const authenticate = () => {
  return (dispatch, getState) => {
    //dispatch({type: AUTHENTICATE_REQUEST});

    return _awsAmplify.Auth.currentAuthenticatedUser().then(response => {
      return _awsAmplify.Auth.currentUserInfo(response).then(() => {
        dispatch({
          type: _actionTypes.AUTHENTICATE_SUCCESS,
          data: response
        });
        return response;
      }).catch(err => console.dir(err));
    }).catch(error => {
      dispatch({
        type: _actionTypes.AUTHENTICATE_FAILURE,
        data: typeof error === "string" ? {
          message: error
        } : error
      });

      // eslint-disable-next-line default-case
      switch (error.code) {
        case _actionTypes.PASSWORD_RESET_REQUIRED_EXCEPTION:
          dispatch({
            type: _actionTypes.PASSWORD_RESET_REQUIRED_EXCEPTION,
            data: error.message
          });
      }
      throw error;
    });
  };
};
exports.authenticate = authenticate;
const getMe = (params, useAuthentication = true) => {
  return dispatch => {
    return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
      request.method = "get";
      request.url = `/users/me${(0, _helpers.paramsToString)(params)}`;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        dispatch({
          type: _actionTypes.GET_ME_SUCCESS,
          data: response.data
        });
        return response.data;
      }).catch(err => {
        if (err.response.data.Code === 125) {
          dispatch({
            type: _actionTypes.ACTIVATE_MAINTENANCE_MODE,
            data: err.response.data.Message
          });
        } else {
          dispatch({
            type: _actionTypes.GET_ME_FAILURE,
            data: err.response.data
          });
        }
      });
    }).catch(err => console.dir(err));
  };
};
exports.getMe = getMe;
const updateMe = (body, params, token, useAuthentication = true) => {
  return dispatch => {
    dispatch({
      type: _actionTypes.UPDATE_ME_REQUEST
    });
    return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
      request.method = "put";
      request.url = `/users/me${(0, _helpers.paramsToString)(params)}`;
      request.data = body;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        dispatch({
          type: _actionTypes.UPDATE_ME_SUCCESS,
          data: response.data
        });
        return response.data;
      }).catch(error => {
        dispatch({
          type: _actionTypes.UPDATE_ME_FAILURE,
          data: error.response.data
        });
        throw error.response.data;
      });
    }).catch(error => {
      console.dir(error);
      dispatch({
        type: _actionTypes.UPDATE_ME_FAILURE,
        data: error
      });
      throw error;
    });
  };
};
exports.updateMe = updateMe;
const signUp = body => {
  return dispatch => {
    dispatch({
      type: _actionTypes.SIGNUP_REQUEST
    });
    return (0, _WebRequestHelper.createRequest)(false).then(request => {
      request.method = "post";
      request.url = "/signup";
      request.data = body;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        dispatch({
          type: _actionTypes.SIGNUP_SUCCESS,
          data: response
        });
      }).catch(error => {
        dispatch({
          type: _actionTypes.SIGNUP_FAILURE,
          data: error.response.data
        });
        throw error;
      });
    }).catch(error => {
      dispatch({
        type: _actionTypes.SIGNUP_FAILURE,
        data: error.response.data
      });
      throw error.response.data;
    });
  };
};
exports.signUp = signUp;
const signOut = () => {
  return dispatch => {
    dispatch({
      type: _actionTypes.SIGNOUT_REQUEST
    });
    return _awsAmplify.Auth.signOut().then(() => {
      dispatch({
        type: _actionTypes.SIGNOUT_SUCCESS
      });
    }).catch(deleteSessionError => {
      console.error("Error deleting session:", deleteSessionError);
      dispatch({
        type: _actionTypes.SIGNOUT_FAILURE,
        data: deleteSessionError
      });
    }).catch(error => {
      dispatch({
        type: _actionTypes.SIGNOUT_FAILURE,
        data: typeof error === "string" ? {
          message: error
        } : error
      });
    });
  };
};
exports.signOut = signOut;
const quit = () => {
  return dispatch => {
    dispatch({
      type: _actionTypes.SIGNOUT_REQUEST
    });
    return _awsAmplify.Auth.signOut().then(() => {
      dispatch({
        type: _actionTypes.QUIT_SUCCESS
      });
    }).catch(deleteSessionError => {
      console.error("Error deleting session:", deleteSessionError);
      dispatch({
        type: _actionTypes.SIGNOUT_FAILURE,
        data: deleteSessionError
      });
    }).catch(error => {
      dispatch({
        type: _actionTypes.SIGNOUT_FAILURE,
        data: typeof error === "string" ? {
          message: error
        } : error
      });
    });
  };
};
exports.quit = quit;
const signIn = (username, password) => {
  return dispatch => {
    //dispatch({type: SIGNIN_REQUEST, data: { username }});

    return _awsAmplify.Auth.signIn(username, password).then(response => {
      dispatch({
        type: _actionTypes.SIGNIN_SUCCESS,
        data: response
      });
      return response;
    }).catch(error => {
      if (error.code === "UserNotConfirmedException") {
        error.message = "Your account is not confirmed. Please verify your email first.";
        dispatch({
          type: _actionTypes.SIGNIN_FAILURE,
          data: error
        });
      } else if (error.message === "PostAuthentication failed with error You are not allowed to log in. Maybe your license expired..") {
        error.message = "Your account was deactivated. If you had a demo/trial account, your trial has ended. Please contact the app provider to resolve this issue.";
        dispatch({
          type: _actionTypes.NO_LOGIN_PERMISSION_EXCEPTION,
          data: error
        });
      } else {
        console.dir(error);
        dispatch({
          type: _actionTypes.SIGNIN_FAILURE,
          data: typeof error === "string" ? {
            message: error
          } : error
        });
      }
      throw error;
    });
  };
};
exports.signIn = signIn;
const changePassword = (oldPassword, newPassword) => {
  //return dispatch => {

  //dispatch({type: CHANGE_PASSWORD_REQUEST});

  return _awsAmplify.Auth.currentAuthenticatedUser().then(cognitoUser => {
    return _awsAmplify.Auth.changePassword(cognitoUser, oldPassword, newPassword).then(response => {
      //dispatch({type: CHANGE_PASSWORD_SUCCESS});

      return response;
    }).catch(error => {
      //dispatch({type: CHANGE_PASSWORD_FAILURE, data: (typeof error === 'string' ? { message: error } : error)});

      throw error;
    });
  }).catch(error => {
    throw error;
  });
};
exports.changePassword = changePassword;
const newPassword = (user, password) => {
  return dispatch => {
    dispatch({
      type: _actionTypes.NEW_PASSWORD_REQUEST
    });
    return _awsAmplify.Auth.completeNewPassword(user, password).then(response => {
      dispatch({
        type: _actionTypes.NEW_PASSWORD_SUCCESS
      });
      return response;
    }).catch(error => {
      dispatch({
        type: _actionTypes.NEW_PASSWORD_FAILURE,
        data: typeof error === "string" ? {
          message: error
        } : error
      });
      throw error;
    });
  };
};
exports.newPassword = newPassword;
const requestCode = username => {
  return dispatch => {
    dispatch({
      type: _actionTypes.SEND_VERIFICATION_CODE_REQUEST
    });
    return _awsAmplify.Auth.forgotPassword(username).then(response => {
      dispatch({
        type: _actionTypes.SEND_CODE_SUCCESS,
        data: {
          username
        }
      });
      return response;
    }).catch(error => {
      dispatch({
        type: _actionTypes.SEND_CODE_FAILURE,
        data: typeof error === "string" ? {
          message: error
        } : error
      });
      throw error;
    });
  };
};
exports.requestCode = requestCode;
const resetPassword = (username, code, password) => {
  return dispatch => {
    dispatch({
      type: _actionTypes.RESET_PASSWORD_REQUEST
    });
    return _awsAmplify.Auth.forgotPasswordSubmit(username, code, password).then(response => {
      dispatch({
        type: _actionTypes.RESET_PASSWORD_SUCCESS
      });
      return response;
    }).catch(error => {
      switch (error.code) {
        case "ExpiredCodeException":
          error.message = "Invalid code provided. Please check the spelling or request a new one.";
          dispatch({
            type: _actionTypes.RESET_PASSWORD_FAILURE,
            data: typeof error === "string" ? {
              message: error
            } : error
          });
          break;
        case "InvalidParameterException":
          error.message = "Invalid code provided. Please check the spelling or request a new one.";
          dispatch({
            type: _actionTypes.RESET_PASSWORD_FAILURE,
            data: typeof error === "string" ? {
              message: error
            } : error
          });
          break;
        default:
          dispatch({
            type: _actionTypes.RESET_PASSWORD_FAILURE,
            data: typeof error === "string" ? {
              message: error
            } : error
          });
      }
      throw error;
    });
  };
};
exports.resetPassword = resetPassword;